class Alert {
  static types = ['alert-info', 'alert-error', 'alert-success', 'alert-warning'];
  constructor(type, message) {
    this.id = Date.now() + Math.random();
    this.type = type; // e.g., 'info', 'error', 'success'
    this.message = message;
    this.timestamp = new Date();
  }
}

export default Alert;